module.exports = (__webpack_require__("8kch"))(244);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/redux-first-router-link/dist/index.js from dll-reference vendor_9144673b21133fc50009
// module id = wHKe
// module chunks = 0